<template>
  <div
    :class="[`amount-card--${appearance}`]"
    class="amount-card"
  >
    <div class="amount-box is-flex direction-column">
      <div class="is-flex justify-space-between">
        <span class="is-size-10 has-text-weight-medium card-info">
          {{ info }}
        </span>
        <span class="is-size-10 has-text-weight-medium card-label">
          {{ label }}
        </span>
      </div>
      <div class="is-flex justify-end">
        <span class="is-size-3 has-text-weight-light card-value">
          {{ formattedAmount }} {{ symbolAmount }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'AmountCard',
  props: {
    appearance: {
      type: String,
      default: 'primary',
      validator: a => ['primary', 'secondary', 'sales', 'offers', 'returns', 'orders'].includes(a),
    },
    label: { type: String, required: true },
    info: { type: String, default: null },
    amount: { type: [String, Number], required: true },
    symbolAmount: { type: String, default: '' },
  },
  computed: {
    formattedAmount() {
      return this.$filters.currency(this.amount);
    },
  },
};
</script>

<style lang="scss">

.amount-card{
  padding: 0.5rem;
  border-radius: 0.5rem;
  box-shadow: 0 2px 2px 0 rgba(0,0,0,0.20);
  min-width: 180px;

  &--primary, &--sales{
    background-color: $green-emerald;
    .card-info {
      color: $green-sulu;
    }
  }
  &--offers{
    background-color: $orange;
    .card-info {
      color: $frangipani;
    }
  }
  &--secondary, &--returns{
    background-color: $red-orange;
    .card-info {
      color: $coral;
    }
  }
  &--orders{
    background-color: $yellow-supernova;
    .card-info {
      color: $cream-brulee;
    }
  }

  .card-label {
    color: $white;
    .card-info {
      color: $white;
    }
  }
  .card-value {
    color: $white;
    margin-right: 2px;
    text-shadow: 0 1px 0 rgba(0,0,0,0.15);
    line-height: normal;
  }
}


</style>
